<template>
  <section>
    <div id="offer">
      <div id="offer-meta">
        <div id="status">unverbindliche Antwort in 24h</div>
      </div>
      <div v-if="hasTemplates" id="exit">
        <rounded-button @click.native="saveConfig()" link="/projekte" :btn-text="heading" btn-color="blue" btn-icon="check" />
      </div>
      <div v-else>
        Wählen Sie mindestens ein Template aus.
      </div>
    </div>
  </section>
</template>
<script>
import RoundedButton from '@/components/RoundedButton.vue'
export default {
  name: 'AngebotBanner',
  components: {
    RoundedButton
  },
  props: {
    heading: {
      type: String,
      default: 'Angebot anfordern'
    }
  },
  computed: {
    hasTemplates: function () {
      if (this.hasBlog || this.hasShop || this.hasPageTemplates) {
        return true
      } else {
        return false
      }
    },
    hasPageTemplates: function () {
      return this.$root.items.find(item => item.id === 'pages').status
    },
    hasShop: function () {
      return this.$root.items.find(item => item.id === 'onlineshop').status
    },
    hasBlog: function () {
      return this.$root.items.find(item => item.id === 'blogfunktion').status
    }
  },
  methods: {
    saveConfig: function () {
      console.log('trying to save')
      if (this.$root.loggedIn) {
        this.$root.addConfiguration()
      } else {
        this.$root.saveWaiting = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/css/variables.scss";
section {
  width: 100%;
  height: 120px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  background-color: rgba(255, 255, 255, 1);
  border-top: 2px solid $primaryColor;
  #offer {
    font-family: $secondaryFont;
    font-weight: $secondaryFontNormal;
    width: 100%;
    padding: 0 15px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    flex-direction: column;
    #offer-meta,
    #exit {
      text-align: center;
      width: 100%;
    }
    #offer-meta {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }
    #toPay {
      margin-right: 20px;
      font-size: 24px;
      font-family: $primaryFont;
      font-weight: $primaryFontBold;
    }
    #status {
      display: flex;
      align-items: center;
      position: relative;
    }
    #status:before {
      content: '';
      display: block;
      width: 10px;
      height: 10px;
      background: #53FF86;
      border-radius: 5px;
      margin-right: 6px;
    }
    #status:after {
      content: '';
      display: block;
      width: 10px;
      height: 10px;
      background: #53FF86;
      border-radius: 5px;
      position: absolute;
      left: 0;
      top: 7px;
      opacity: 0.6;
      animation-name: statusUpdate;
      animation-duration: 1s;
      animation-delay: 1s;
      animation-timing-function: ease-in-out;
      animation-iteration-count: infinite;
    }
  }
}
@supports ((-webkit-backdrop-filter: blur(8px)) or (backdrop-filter: blur(8px))) {
  section {
    background-color: rgba(255, 255, 255, 0.92);
    -webkit-backdrop-filter: blur(8px);
    backdrop-filter: blur(8px);
  }
}
@keyframes statusUpdate {
  from {
    transform: scale(1);
    opacity: 0.6;
  } to {
    transform: scale(2.6);
    opacity: 0;
  }
}
@media (min-width: 580px) {
  section {
    height: 80px;
    #offer {
      flex-direction: row;
      #offer-meta,
      #exit {
        text-align: left;
        width: 50%;
      }
      #offer-meta {
        flex-direction: column;
        align-items: start;
      }
    }
  }
}
@media (min-width: 767px) {
  section {
    padding: 0 0 0 102px; // large menu closed, mini overview width
    #offer {
      padding: 0 40px;
    }
  }
}
@media(min-width:1180px) {
  .closed-large-overview section {
    padding: 0 0 0 102px; // large menu closed, mini overview width
  }
  section {
    padding: 0 0 0 280px; // large menu open, large menu width
  }
}
/* disable offer meta on very small screens */
@media (max-height: 320px) and (max-width: 579px) {
  section {
    #offer-meta {
      display: none!important;
    }
    height: 60px;
  }
}
</style>
